import React from "react";
import { Fade } from "react-awesome-reveal";
import Button from "../elements/Button";

export default function Portfolio({ data }) {
  return (
    <section className="container mx-auto flex flex-col items-center mt-20 bg-green-50 py-12">
      <Fade direction="right" triggerOnce>
        <h1 className="text-5xl text-green-800 text-center font-bold">
          Our Selected Projects
        </h1>
      </Fade>
      <Fade direction="left" triggerOnce>
        <p className="font-light text-lg text-green-600 text-center mb-12">
          We are ready to scale up your business with our great work results.
        </p>
      </Fade>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 justify-items-center">
        {data.slice(0, 3).map((item, index) => (
          <Fade direction="up" triggerOnce delay={500 * index} key={index}>
            <Button type="link">
              <div className="group rounded-2xl shadow-xl w-auto m-4 transform transition duration-500 hover:scale-110 hover:shadow-2xl portfolio-card">
                <div className="relative overflow-hidden rounded-t-2xl">
                  <img
                    src={item.imageUrl}
                    alt="Portfolio"
                    className="rounded-t-2xl transition duration-300 transform group-hover:scale-105 w-full h-60 object-cover"
                  />
                  <div className="absolute w-full h-full top-0 opacity-0 bg-black bg-opacity-50 group-hover:opacity-100 transition-opacity duration-300 flex justify-center items-center rounded-t-2xl">
                    <button className="focus:outline-none">
                      <svg
                        className="w-20 h-20 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="py-4 text-center">
                  <h2 className="text-green-700 text-xl font-semibold">
                    {item.title}
                  </h2>
                  <p className="font-light text-green-500">{item.type}</p>
                </div>
              </div>
            </Button>
          </Fade>
        ))}
      </div>

      <Fade bottom triggerOnce>
        <Button
          href="/project"
          type="link"
          className="flex items-center justify-center mt-14 w-40 h-14 text-green-600 border-2 border-green-600 rounded-full hover:bg-green-600 hover:text-white transition duration-300"
        >
          <p className="font-normal text-lg">See More</p>
          <svg
            className="w-4 h-4 ml-2"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </Button>
      </Fade>
    </section>
  );
}
